/**
 * Exporta a XLSX el Reporte de Estudiantes Nuevo Ingreso.
 */
import * as XLSX from 'xlsx';
import { getTurnoLabel } from '../constants/turnos';

const COLUMNAS = [
  '#',
  'MATRICULA',
  'CICLO ESCOLAR DE',
  'SECCIÓN',
  'PROGRAMA ACADÉMICO',
  'TURNO',
  'NOMBRE COMPLETO',
  'CORREO PERSONAL',
  'TELÉFONO',
  'CELULAR',
  'CORREO INSTITUCIONAL',
  'FECHA DE NACIMIENTO',
  'EDAD',
  'GÉNERO',
  'LUGAR DE NACIMIENTO',
  'CURP',
  'NACIONALIDAD',
  'FECHA DE REGISTRO',
  'ESCUELA DE PROCEDENCIA',
  'NOMBRE DE RESPONSABLE DE CAPTURA',
  'ESTATUS',
  'ESTADO CIVIL',
  'PADRE',
  'OCUPACIÓN DEL PADRE',
  'MADRE',
  'OCUPACIÓN DE LA MADRE',
  'DOMICILIO',
];

function fechaArchivo() {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}_${pad(d.getHours())}${pad(d.getMinutes())}`;
}

export function exportReporteNuevosIngresosXLS({ resultados = [], contexto = {} } = {}) {
  const {
    ciclo = 'Todos',
    campus = 'Todos',
    seccion = 'Todas',
    programa = 'Todos',
  } = contexto;

  const aoa = [
    ['REPORTE ESTUDIANTES NUEVO INGRESO'],
    [`Ciclo Escolar: ${ciclo}`],
    [`Campus: ${campus}`],
    [`Sección: ${seccion}`],
    [`Programa: ${programa}`],
    [`Generado: ${new Date().toLocaleString('es-MX')}`],
    [],
    COLUMNAS,
  ];

  resultados.forEach((r, idx) => {
    aoa.push([
      r.numero ?? (idx + 1),
      r.matricula || '',
      r.ciclo_escolar || '',
      r.seccion || '',
      r.programa || '',
      (typeof getTurnoLabel === 'function' ? getTurnoLabel(r.turno) : (r.turno || '')) || '',
      r.nombre_completo || '',
      r.correo_personal || '',
      r.telefono || '',
      r.celular || '',
      r.correo_institucional || '',
      r.fecha_nacimiento || '',
      r.edad ?? '',
      r.genero || '',
      r.lugar_nacimiento || '',
      r.curp || '',
      r.nacionalidad || '',
      r.fecha_registro || '',
      r.escuela_procedencia || '',
      r.responsable_captura || '',
      r.estatus || '',
      r.estado_civil || '',
      r.padre || '',
      r.ocupacion_padre || '',
      r.madre || '',
      r.ocupacion_madre || '',
      r.domicilio || '',
    ]);
  });

  const ws = XLSX.utils.aoa_to_sheet(aoa);

  ws['!cols'] = [
    { wch: 5 },  { wch: 14 }, { wch: 18 }, { wch: 16 }, { wch: 32 },
    { wch: 12 }, { wch: 32 }, { wch: 28 }, { wch: 14 }, { wch: 14 },
    { wch: 30 }, { wch: 14 }, { wch: 6 },  { wch: 12 }, { wch: 24 },
    { wch: 20 }, { wch: 16 }, { wch: 16 }, { wch: 28 }, { wch: 28 },
    { wch: 14 }, { wch: 14 }, { wch: 28 }, { wch: 22 }, { wch: 28 },
    { wch: 22 }, { wch: 60 },
  ];

  ws['!merges'] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: COLUMNAS.length - 1 } },
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Nuevo Ingreso');

  const fileName = `reporte_estudiantes_nuevo_ingreso_${fechaArchivo()}.xlsx`;
  XLSX.writeFile(wb, fileName);
}

export default exportReporteNuevosIngresosXLS;
